import NameOrEmail from "../../components/NameOrEmail";
import { order } from "../SmartSearchParammeter";

export default async function NameOrEmailConfig(key) {
  return {
    description: "Name or Email",
    id: "nameOrEmail",
    initial: undefined,
    type: order.third,
    handleValues: (searchObject) => {
      return;
    },

    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <NameOrEmail searchObject={searchObject} onChange={onChange} t={t} />
      </div>
    ),
    operation: ["Exact", "Like"],
    list: [],

    handler: function (searchObj, value) {
      searchObj["nameOrEmail"] = value[0];
    }
  };
}
